import { ElementTypeEnum } from 'projects/shared/src/lib/core/enums/element-type.enum';
import { MathOperationEnum } from 'projects/shared/src/lib/core/enums/math-operation.enum';
import { TaskItemElement } from 'projects/shared/src/lib/core/interfaces/task-item-element';

export const isResponseElement = (type?: ElementTypeEnum) => {
  if (type === undefined) return false;
  return [
    ElementTypeEnum.InlineAnswer,
    ElementTypeEnum.SeparateAnswer,
    ElementTypeEnum.NominatorAnswer,
    ElementTypeEnum.DenominatorAnswer,
    ElementTypeEnum.ComparisonAnswer,
  ].includes(type);
}

export const getMathOperationSign = (type: MathOperationEnum) => {
  switch (type) {
    case MathOperationEnum.Addition:
      return '+';
    case MathOperationEnum.Deduction:
      return '-';
    case MathOperationEnum.Multiplication:
      return '×';
    case MathOperationEnum.Division:
      return ':';
  }
}

export const getDenominatorsByNominatorType = (
  elements: TaskItemElement[],
  type: ElementTypeEnum
): Record<number, TaskItemElement> => {
  return elements.reduce((denominators, currentElement) => {
    if (currentElement.type !== type) return denominators;
    return {
      ...denominators,
      [currentElement.order]: elements.find(el => el.order === currentElement.order + 1),
    };
  }, {});
}

export const isComparisonAnswer = (el: TaskItemElement) => {
  return (el.type && [
    ElementTypeEnum.ComparisonAnswer,
    ElementTypeEnum.InlineAnswer,
    ElementTypeEnum.SeparateAnswer,
  ].includes(el.type));
}

export const capitalizeFirstLetter = (text: string): string => {
  return text.charAt(0).toUpperCase() + text.slice(1);
}

// from TAR-315
export const getHardcodedSubArraysLength = (length: number): number[] | undefined => {
  switch (length) {
    case (9):
      return [5,4];
    case (11):
      return [6,5];
    case (13):
      return [7,6];
    case (17):
      return [6,6,5];
    case (19):
      return [7,6,6];
    case (22):
      return [6,6,6,4];
    case (23):
      return [6,6,6,5];
    case (26):
      return [7,7,7,5];
    case (27):
      return [7,7,7,6];
    case (29):
      return [6,6,6,6,5];
      default:
        return undefined;
  }
}
